import { tableParams, type TableCriteria } from '../../components/common/tables/tableQuery';
export type UsersTableCriteria = TableCriteria;
export function usersTableParams(criteria: TableCriteria): URLSearchParams {
  return tableParams(criteria, new Set(['date_joined', 'last_login']));
}
